import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { TopBar } from "./TopBar";
import { LiveTicker } from "./LiveTicker";
import { MobileTabBar } from "./MobileTabBar";
import { ScrollToTop } from "./ScrollToTop";
import { ErrorBoundary } from "@/components/common/ErrorBoundary";

export function AppShell() {
  return (
    <div className="flex min-h-screen bg-base-900">
      <ScrollToTop />
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <TopBar />
        <ErrorBoundary fallbackTitle="Live ticker unavailable">
          <LiveTicker />
        </ErrorBoundary>
        {/* pb-24 on mobile clears the fixed bottom tab bar so the last card
            in any list is never hidden behind it */}
        <main className="flex-1 px-4 md:px-6 py-6 pb-24 md:pb-6 max-w-[1600px] w-full mx-auto">
          <ErrorBoundary fallbackTitle="This page hit a snag">
            <Outlet />
          </ErrorBoundary>
        </main>
      </div>
      <MobileTabBar />
    </div>
  );
}
